export const LANG_TH_CONFIG = {
  homePage: {
    topbar: {
      language: 'ภาษา',
      english: 'อังกฤษ',
      thai: 'ไทย',
      loginRegister: 'เข้าสู่ระบบ/สมัครสมาชิก',
      myAddress: 'ที่อยู่ของฉัน',
      myOrder: 'การสั่งซื้อของฉัน',
      myReturn: 'การคืนสินค้าของฉัน',
      myVoucher: 'บัตรกำนัลของฉัน',
      SignOut: 'ออกจากระบบ',
      checkStatusOrder: 'ตรวจสอบสถานะการสั่งซื้อ'
    },
    navbar: {
      search: 'ค้นหา',
      cart: 'ตะกร้า'
    },
    dialogSignIn: {
      signFb: 'เข้าสู่ระบบด้วยบัญชีเฟซบุ๊ก',
      oR: 'หรือ',
      email: 'อีเมล์',
      password: 'รหัสผ่าน',
      forgetPassword: 'ลืมรหัสผ่าน',
      resetPassword: 'รีเซ็ตรหัสผ่าน',
      subReset: 'ป้อนที่อยู่อีเมลที่เชื่อมโยงกับบัญชีของคุณเพื่อรีเซ็ตรหัสผ่าน',
      buttonSent: 'ส่งลิงก์เพื่อรีเซ็ตรหัสผ่าน',
      signIn: 'เข้าสู่ระบบ',
      name: 'ชื่อ',
      lastName: 'นามสกุล',
      signUp: 'สมัครสมาชิก',
      dontAccount: 'คุณยังไม่สมัครสมาชิกใช่ไหม ?',
      alreadyHaveAnAccount: 'เป็นสมาชิกอยู่แล้วใช่ไหม ?'
    },
    newArrivals: {
      newArr: 'สินค้ามาใหม่',
      sale: 'ลดราคา',
      hot: 'ขายดี',
      outOfStock: 'สินค้าหมด'
    },
    categorie: {
      ACCESSORY: 'เครื่องประดับ',
      APPAREL: 'เครื่องแต่งกาย',
      'COLLECTIBLES&TOYS': 'ของเล่นและของสะสม',
      'HOME APPLIANCES': 'ของใช้ในบ้าน',
      PROMOTIONS: 'โปรโมชั่น',
      EXCLUSIVE: 'พิเศษ'
    },
    footer: {
      aboutus: 'เกี่ยวกับเรา',
      branches: 'สาขา',
      how: 'วิธีการสั่งซื้อสินค้า',
      track: 'เช็คสถานะพัสดุ',
      fb: 'ติดตามพวกเราบน Facebook',
      tw: 'ติดตามพวกเราบน Twitter',
      ig: 'ติดตามพวกเราบน Instagram',
      yt: 'ติดตามพวกเราบน Youtube'
    }
  },
  productPage: {
    product: {
      color: 'สี',
      size: 'ขนาด',
      material: 'ข้อมูลจำเพาะ',
      only: 'มีสินค้าเหลือแค่',
      promotionCondition: 'เงื่อนไข',
      only2: 'ชิ้น',
      addToCart: 'เพิ่มลงตะกร้า',
      buyNow: 'ซื้อเลย',
      share: 'แชร์',
      expireDate: 'ใช้ได้ถึง ',
      promotion: 'ส่วนลดโปรโมชัน',
      limit: {
        before: 'จำกัดจำนวน',
        after: 'ใบต่อครั้ง'
      }
    },
    dialogAdd: {
      title: 'เอสเอฟ ช้อป',
      bodyMessage: 'เพิ่มสินค้าลงในตะกร้าสำเร็จ'
    },
    dialogOutOfStock: {
      title: 'เอสเอฟ ช้อป',
      bodyMessage: 'ขออภัยสินค้าหมด',
      close: 'ปิด'
    }
  },

  cartPage: {
    cartTotal: {
      cartTotals: 'รายการสั่งซื้อ',
      order: 'จำนวนสินค้า',
      total: 'จำนวนเงินรวม',
      subTotal: 'รวมสินค้า',
      discountCode: 'รหัสส่วนลด',
      promotion: 'ส่วนลดโปรโมชัน',
      proceedToCheckout: 'ยืนยัน',
      confirm: 'ยืนยัน'
    },
    avaliableOrder: {
      cart: 'ตะกร้า',
      avaliableOrder: 'รายการสินค้า',
      product: 'รายการสินค้า',
      price: 'ราคา',
      quantity: 'จำนวน',
      total: 'รวม',
      promotion: 'โปรโมชัน'
    },
    unavaliableOrder: {
      unavaliableOrder: 'รายการสินค้าไม่พร้อมจำหน่าย',
      btnDelUnAvaliableOrder: 'ลบรายการที่เลือก'
    },
    promotionCart: {
      title: 'โปรโมชันที่ได้รับ'
    },
    dialogDeleteItemInCart: {
      title: 'คุณต้องการที่จะลบรายการที่เลือกใช่หรือไม่ ?',
      ok: 'ลบ',
      cancle: 'ยกเลิก'
    },
    dialogDeleteUnAvaliableItemInCart: {
      title: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการเหล่านี้ ?',
      bodyMessage: 'ลบรายการที่เลือกทั้งหมด',
      ok: 'ลบ',
      cancle: 'ยกเลิก'
    },
    cartEmpty: {
      titleEmpty: 'ไม่พบสินค้าในตะกร้า',
      bodyMessage: 'ไปช้อปปิ้งกันเถอะ',
      urlMessage1: 'ไปที่',
      urlMessage2: ' หน้าหลัก'
    },
    cartBeforeConfirmOrder: {
      title: 'เอสเอฟ ช้อป',
      bodyMessage: 'โปรดเลือกสินค้าก่อนดำเนินการชำระเงิน',
      close: 'ปิด'
    }
  },
  checkoutPage: {
    checkout: {
      title: 'ชำระเงิน',
      purchaseOrder: 'รายการสั่งซื้อ',
      size: 'ขนาด',
      color: 'สี',
      checking: 'กำลังตรวจสอบ...'
    },
    checkoutEmpty: {
      titleEmpty: 'ไม่พบสินค้าในเช็คเอาท์',
      bodyMessage: 'ไปช้อปปิ้งกันเถอะ',
      urlMessage1: 'ไปที่',
      urlMessage2: ' หน้าหลัก'
    },
    PurchaseOrderTableHeader: {
      Product: 'รายการสินค้า',
      Price: 'ราคา',
      Quantity: 'จำนวน',
      Total: 'รวม'
    },
    shippingAddress: {
      title: 'ที่อยู่สำหรับจัดส่งสินค้า',
      add: 'เพื่มที่อยู่ใหม่',
      default: 'ค่าเริ่มต้น',
      change: 'เปลี่ยน',
      manageAddress: 'จัดการที่อยู่',
      ok: 'ยืนยัน',
      cancel: 'ยกเลิก'
    },
    EmailAddress: {
      title: 'อีเมลสำหรับจัดส่ง'
    },
    taxInvoiceAddress: {
      title: 'ที่อยู่สำหรับออกใบกำกับภาษี',
      add: 'เพื่มที่อยู่ใหม่',
      default: 'ค่าเริ่มต้น',
      change: 'เปลี่ยน',
      manageAddress: 'จัดการที่อยู่',
      ok: 'ยืนยัน',
      cancel: 'ยกเลิก'
    },
    paymentMethod: {
      title: 'เลือกช่องทางการชำระเงิน',
      creditDebitCard: 'บัตรเครดิต / บัตรเดดิต',
      sfPlus: 'เอสเอฟพลัส',
      qrCode: 'คิวอาร์โค้ด',
      sfPlusBalance: 'ยอดคงเหลือ',
      sfPlusWallet: 'กระเป๋าเงินเอสเอฟพลัส'
    },
    submit: {
      subtotal: 'รวมสินค้า',
      shipping: 'ค่าจัดส่ง',
      total: 'จำนวนเงินรวม',
      reqInvTax: 'ต้องการออกใบกำกับภาษี',
      purchase: 'ซื้อ',
      promotion: 'ส่วนลดโปรโมชัน'
    },
    dialogPin: {
      title: 'ตรวจสอบพินเอสเอฟพลัส',
      inputPin: 'ระบุพิน',
      ok: 'ตรวจสอบ',
      cancle: 'ปิด'
    },
    dialogThaiQR: {
      title: 'QR CODE PAYMENT',
      WaitingForPayment: 'รอการชำระเงิน...',
      PaymentCompleted: 'ชำระเงินเรียบร้อย',
      WaitingForQRcode: 'กรุณารอสักครู่...'
    },
    dialogConfirmCancelThaiQr: {
      title: "คุณต้องการยกเลิกการชำระเงินใช่หรือไม่ ?",
      yes: "ใช่",
      no: "ไม่ใช่"
    },
    dialogPolicy: {
      title: 'เอสเอฟ ช้อป',
      bodyMessage: {
        title:
          'นโยบายการเปลี่ยนสินค้า คืนสินค้าและคืนเงิน กรณีซื้อสินค้าผ่านช่องทางออนไลน์',
        paragraph1: `ผู้ซื้อสามารถแจ้งความประสงค์เพื่อทำการขอเปลี่ยนสินค้า/คืนสินค้าและขอรับเงินคืนได้ ในกรณีที่สินค้าเข้าเงื่อนไขดังต่อไปนี้ โดยผู้ซื้อจะต้องส่งสินค้ากลับภายใน 7 วันหลังจากได้รับสินค้า และทางบริษัทฯ จะทำการคืนเงินให้ ภายใน 15 วันทำการ หรือตามเงื่อนไขของทางธนาคาร`,
        paragraph2:
          'ก. สินค้ามีตำหนิ คือ สินค้าที่เสียหายทางกายภาพ เช่น บุบ มีตำหนิ เมื่อส่งถึงมือลูกค้าและ/หรืออยู่ในบรรจุภัณฑ์ที่ชำรุด',
        paragraph3:
          'ข. สินค้าผิด/ไม่ถูกต้อง คือ สินค้าที่ได้รับมีความแตกต่างจากหรือไม่ตรงกับหน้าเว็ปไซต์/ไม่ตรงกับที่สั่งซื้อ',
        paragraph4:
          'ค. สินค้า / อุปกรณ์ หรือชิ้นส่วนของสินค้าสูญหายหรือได้รับไม่ครบ รวมทั้งสินค้าไม่สามารถใช้การได้ คือ อุปกรณ์ ชิ้นส่วนสินค้า หรือฟังก์ชันการใช้งานไม่เป็นไปตามที่อธิบายไว้ในคู่มือสินค้า',
        paragraph5:
          'ง. สินค้าไม่ตรงตามข้อมูลบนเว็ปไซต์ สินค้าที่ได้รับไม่ตรงตามรายละเอียดที่แจ้งบนเว็ปไซต์ เช่น รูป ลักษณะสินค้า ลวดลาย วัสดุที่ใช้ และอื่นๆ',
        paragraph6:
          '1. การเปลี่ยนสินค้า ผู้ซื้อสามารถแจ้งความประสงค์เพื่อเปลี่ยนสินค้าได้ภายใน 7 วันนับจากวันได้รับสินค้า',
        paragraph7:
          '1.1 การเปลี่ยนสินค้า บริษัทฯ ขอสงวนสิทธิ์ สินค้าที่เปลี่ยนใหม่ต้องเป็นสินค้ารายการเดียวกันกับที่ผู้ซื้อได้ทำการซื้อแล้วเท่านั้น โดยผู้ซื้อสามารถแจ้งเปลี่ยนเฉพาะสินค้าที่มีปัญหาได้ 1 รอบ/คำสั่งซื้อเท่านั้น',
        paragraph8:
          '1.2 การเปลี่ยนสินค้า บริษัทฯ และผู้ซื้อต้องยินยอมร่วมกันทั้งสองฝ่าย บริษัทฯ ขอสงวนสิทธิ์สามารถปฏิเสธการเปลี่ยนสินค้าได้หากมีเหตุผลที่เหมาะสม',
        paragraph9:
          '1.3 ในการเปลี่ยนสินค้า ผู้ซื้อต้องส่งสินค้ากลับคืนมายังบริษัทฯ ภายใน 7 วัน นับจากวันที่ได้รับสินค้าตามวันที่ประทับตราขนส่ง หากเกินจากระยะเวลาที่กำหนด บริษัทฯ ขอสงวนสิทธิ์ในการไม่รับเปลี่ยนสินค้าทุกกรณี',
        paragraph10:
          '1.4 ผู้ซื้อนำส่งสินค้าที่ต้องการเปลี่ยนมาที่สำนักงานใหญ่ บริษัท เอส เอฟ คอร์ปอเรชั่น จำกัด (มหาชน) ทั้งนี้ผู้ซื้อต้องเป็นผู้รับผิดชอบค่าจัดส่งสินค้ากลับคืนบริษัทฯ เอง ยกเว้น กรณีบริษัทฯ ส่งสินค้าผิด บริษัทฯ จะเป็นผู้รับผิดชอบค่าส่งสินค้า',
        paragraph11:
          '1.5 ระยะเวลาในการดำเนินการเปลี่ยนสินค้า 7-15 วันทำการ นับจากวันที่สำนักงานใหญ่ ได้รับสินค้า',
        paragraph12:
          '1.6 กรณีผู้ซื้อมิได้ส่งสินค้ากลับมายังบริษัทฯ ทางบริษัทฯ ขอสงวนสิทธิ์ไม่ดำเนินการเปลี่ยนสินค้าหรือคืนเงินให้แก่ลูกค้า',
        paragraph13:
          '1.7 บริษัทฯ ขอสงวนสิทธิ์ในการรับเปลี่ยนสินค้าภายใต้นโยบายและเงื่อนไขตามที่บริษัทฯ กำหนดเท่านั้น',
        paragraph14:
          '1.8 บริษัทฯ ขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข เงื่อนไขการเปลี่ยนสินค้าโดยมิต้องแจ้งให้ทราบล่วงหน้า',
        paragraph15:
          '2.การคืนสินค้าและขอรับเงินคืนบริษัทจะทำการคืนเงินให้ในกรณีสินค้าที่ผู้ซื้อต้องการเปลี่ยนไม่มีสต็อคเท่านั้นโดยบริษัทฯ จะทำการคืนเงินให้ ภายใน 15 วันทำการ นับจากวันที่สำนักงานใหญ่ได้รับสินค้า',
        paragraph16: 'ช่องทางการติดต่อ',
        paragraph17: 'E-mail = SFshop@sfcinema.com'
      },
      ok: 'ยอมรับเงื่อนไข',
      cancle: 'ปิด'
    },
    dialogSFPlusInfo: {
      title: 'เอสเอฟ ช้อป',
      linked: 'บัญชีของคุณไม่ได้เชื่อมกับ SF Plus',
      balance: 'ยอดเงินไม่เพียงพอ',
      close: 'ปิด'
    },
    dialogPhoneNumber: {
      title: 'หมายเลขโทรศัพท์',
      phoneNumber: 'หมายเลขโทรศัพท์',
      ok: 'ตกลง',
      cancel: 'ปิด'
    },
    dialogFurtherInformation: {
      title: 'รายละเอียดสำหรับจัดส่ง',
      email: 'อีเมล',
      name: 'ชื่อ',
      lastname: 'นามสกุล',
      phoneNumber: 'หมายเลขโทรศัพท์',
      ok: 'ตกลง',
      cancel: 'ปิด'
    },
    selectShipping: {
      title: "การจัดส่งสินค้า",
      errorBranch: "^ไม่มีอยู่ในรายการ",
      postOffice: "จัดส่งทางไปรษณีย์",
      branch: "เลือกรับสินค้าที่สาขา",
      shippingBranch: {
        title: "สาขาสำหรับรับสินค้า",
        selectBranch: "เลือกสาขา",
        phoneNumber: "เบอร์ติดต่อ"
      }
    }
  },
  SearchPage: {
    search: {
      title: 'ค้นหา'
    },
    categories: {
      title: 'หมวดหมู่สินค้า'
    }
  },
  notFoundPage: {
    title: '404 ไม่พบหน้าที่ค้นหา',
    bodyMessage: 'ไม่พบเนื้อหา',
    urlMessage1: 'ไปที่',
    urlMessage2: 'หน้าหลัก'
  },
  paymentvoucherSuccessPage: {
    title: 'การชำระเงินสำเร็จ',
    bodyMessage: {
      line1: 'รายการสั่งซื้อสินค้าของท่านสำเร็จเรียบร้อยแล้ว',
      line2:
        'ท่านจะได้รับรายละเอียดการทำรายการซื้อสินค้าผ่านทางอีเมล์ที่ลงทะเบียน',
      line3:
        'หากท่านไม่ได้รับอีเมล์กรุณาติดต่อเจ้าหน้าที่ตามช่องทางติดต่อด้านล่าง'
    },
    urlMessage1: 'ไปที่',
    urlMessage2: 'บัตรกำนัลของฉัน'
  },
  paymentSuccessPage: {
    title: 'การชำระเงินสำเร็จ',
    bodyMessage: {
      line1: 'รายการสั่งซื้อสินค้าของท่านสำเร็จเรียบร้อยแล้ว',
      line2:
        'ท่านจะได้รับรายละเอียดการทำรายการซื้อสินค้าผ่านทางอีเมล์ที่ลงทะเบียน',
      line3:
        'หากท่านไม่ได้รับอีเมล์กรุณาติดต่อเจ้าหน้าที่ตามช่องทางติดต่อด้านล่าง'
    },
    urlMessage1: 'ไปที่',
    urlMessage2: 'การสั่งซื้อของฉัน'
  },
  paymentFailurePage: {
    title: 'การชำระเงินล้มเหลว',
    bodyMessage: 'มีบางอย่างผิดพลาด.',
    urlMessage1: 'ไปที่',
    urlMessage2: 'การสั่งซื้อของฉัน'
  },
  paymentCancelledPage: {
    title: 'การชำระเงินถูกยกเลิก',
    bodyMessage: 'การชำระเงินถูกยกเลิกโดยลูกค้า',
    urlMessage1: 'ไปที่',
    urlMessage2: 'การสั่งซื้อของฉัน'
  },
  purchase: {
    YourOrder: 'ไม่พบข้อมูลการสั่งซื้อสินค้าของคุณ',
    invoiceNo: 'หมายเลขการสั่งซื้อ :',
    orderDate: 'วันที่การสั่งซื้อ :',
    status: 'สถานะ :',
    deliveryNo: 'หมายเลขติดตามพัสดุ:',
    product: 'สินค้า',
    price: 'ราคา',
    quantity: 'จำนวน',
    color: 'สี:',
    shippingAddress: 'ที่อยู่ในการจัดส่ง :',
    taxInvoiceAddress: 'ที่อยู่สำหรับออกใบกำกับภาษี :',
    subtotal: 'รวม',
    shipping: 'ค่าจัดส่ง',
    total: 'รวมทั้งหมด',
    discount: 'ส่วนลด',
    buttonRating: 'ให้คะแนน',
    buttonBuyAgain: 'ซื้ออีกครั้ง',
    pickUpBranch: 'รับสินค้าที่สาขา :',
    since: 'ตั้งแต่วันที่ :'
  },
  usermenu: {
    myAccount: 'บัญชีของฉัน',
    purchase: {
      myPurchase: 'การสั่งซื้อของฉัน',
      all: 'รายการทั้งหมด',
      failed: 'ทำรายการไม่สำเร็จ',
      pending: 'กำลังเตรียมจัดส่ง',
      shipping: 'อยู่ระหว่างขนส่ง',
      // delivered: 'ได้รับสินค้าแล้ว',
      delivered: 'จัดส่งแล้ว',
      return: 'เปลี่ยน/คืนสินค้า',
      formCheckStatusOrder: {
        title: 'ตรวจสอบสถานะการสั่งซื้อ',
        invoice: 'หมายเลขการสั่งซื้อ',
        phoneNumber: 'เบอร์โทรศัพท์',
        ok: 'ตกลง'
      }
    },
    address: {
      myAddress: 'ที่อยู่ของฉัน',
      shippingAddress: {
        title: 'ที่อยู่ในการจัดส่ง',
        name: 'ชื่อ',
        address: 'ที่อยู่',
        phone: 'หมายเลขโทรศัพท์',
        add: 'เพิ่มที่อยู่',
        edit: 'แก้ไข',
        delete: 'ลบ',
        default: 'ค่าเริ่มต้น',
        setdefault: 'ตั้งเป็นค่าเริ่มต้น',
        notHaveShippingAddress: 'คุณยังไม่ได้กำหนดที่อยู่ในการจัดส่ง'
      },
      taxInvoiceAddress: {
        title: 'ที่อยู่สำหรับออกใบกำกับภาษี',
        name: 'ชื่อ',
        taxId: 'เลขประจำตัวผู้เสียภาษี',
        address: 'ที่อยู่',
        phone: 'หมายเลขโทรศัพท์',
        email: 'อีเมล์',
        add: 'เพิ่มที่อยู่',
        edit: 'แก้ไข',
        delete: 'ลบ',
        default: 'ค่าเริ่มต้น',
        setdefault: 'ตั้งเป็นค่าเริ่มต้น',
        notHaveTaxInvoiceAddress: 'คุณยังไม่ได้กำหนดที่อยู่สำหรับออกใบกำกับภาษี'
      },
      dialogShippingAddress: {
        titleCreate: 'ที่อยู่สำหรับจัดส่งสินค้า',
        titleChange: 'แก้ไขอยู่สำหรับจัดส่งสินค้า',
        name: 'ชื่อ',
        lastName: 'นามสกุล',
        address: 'ที่อยู่',
        province: 'เลือกจังหวัด',
        district: 'เลือกอำเภอ',
        subDistrict: 'เลือกตำบล',
        zipcode: 'รหัสไปรษณีย์',
        phoneNumber: 'หมายเลขโทรศัพท์',
        default: 'ค่าเริ่มต้น',
        email: 'อีเมล',
        ok: 'บันทึก',
        cancle: 'ปิด'
      },
      dialogTaxInvoiceAddress: {
        titleCreate: 'ที่อยู่สำหรับออกใบกำกับภาษี',
        titleChange: 'แก้ไขอยู่สำหรับออกใบกำกับภาษี',
        name: 'ชื่อ - นามสกุล / ชื่อบริษัท',
        taxId: 'เลขประจำตัวผู้เสียภาษีอากร',
        phoneNumber: 'หมายเลขโทรศัพท์',
        email: 'อีเมล์',
        address: 'ที่อยู่',
        province: 'เลือกจังหวัด',
        district: 'เลือกอำเภอ',
        subDistrict: 'เลือกตำบล',
        zipcode: 'รหัสไปรษณีย์',
        default: 'ค่าเริ่มต้น',
        ok: 'บันทึก',
        cancle: 'ปิด'
      },
      dialogConfirmDelete: {
        title: 'เอสเอฟ ช้อป',
        bodyMessage: 'ต้องการลบข้อมูลที่เลือก',
        delete: 'ลบ',
        cancel: 'ยกเลิก'
      },
      dialogNotAllowDelete: {
        title: 'เอสเอฟ ช้อป',
        bodyMessage: 'ไม่สามารถลบที่อยู่หลัก',
        ok: 'ตกลง'
      }
    },
    makeReturn: {
      title: 'การเปลี่ยนสินค้า',
      product: 'รายการสินค้า',
      remark: 'เหตุผล',
      quantity: 'จำนวน',
      color: 'สี',
      size: 'ขนาด',
      selectsuccess: 'ยืนยันการเปลี่ยนสินค้า',
      dialog: {
        title: 'เอสเอฟ ช้อป',
        dialogReturnOrderEmpty: 'กรุณาเลือกสินค้าที่จะคืน',
        dialogSelectRemark: 'กรุณาเลือกเหตุผลในการคืนสินค้า',
        dialogOverMaxFile: 'อนุญาตให้อัปโหลดภาพสูงสุด 3 ไฟล์',
        dialogFileTypeNotSupport:
          'อัพโหลดได้เฉพาะไฟล์รูปภาพ (.jpg, .png) เท่านั้น',
        dialogFileRequired: 'กรุณาอัพโหลดรูปภาพอย่างน้อย 1 รูป',
        dialogSubmitError: 'การยื่นเรื่องเปลี่ยนสินค้าล้มเหลวกรุณาลองอีกครั้ง',
        close: 'ปิด'
      },
      captionLabel: {
        details: 'เหตุผลอื่นๆ ในการเปลี่ยนสินค้า',
        upload: ' เลือกรูปภาพที่ต้องการอัพโหลด สูงสุด 3 รูป (.png, .jpg)'
      },
      errorRemark: 'กรุณากรอกเหตุผล'
    },
    return: {
      myReturn: 'การคืนสินค้าของฉัน',
      notFoundData: 'ไม่พบข้อมูลการคืนสินค้าของคุณ',
      status: {
        all: 'รายการทั้งหมด',
        wait: 'กำลังพิจารณา',
        considered: 'พิจารณาแล้ว'
      },
      invoiceNo: 'หมายเลขการสั่งซื้อ :',
      refundDate: 'วันที่ยื่นเรื่องคืนสินค้า :',
      refundStatus: 'สถานะ :',
      refundHeader: 'รายการสินค้า',
      product: 'รายการสินค้า',
      quantity: 'จำนวน',
      remark: 'เหตุผล',
      details: 'เหตุผลอื่นๆ ในการเปลี่ยนสินค้า',
      reference: 'รูปภาพอ้างอิง',
      reply: {
        main: 'สถานะ',
        approve: 'อนุมัติ',
        reject: 'ไม่อนุมัติ',
        type: {
          refund: 'คืนเงิน',
          change: 'เปลี่ยนสินค้า'
        }
      }
    },
    voucher: {
      myVoucher: 'บัตรกำนัลของฉัน',
      empty: 'ไม่พบบัตรกำนัลของคุณ',
      qrCode: 'QR Code',
      barcode: 'Barcode',
      voucherNumber: 'เลขบัตรกำนัล',
      expireDate: 'หมดอายุเมื่อ',
      name: 'ชื่อ',
      invoiceNo: 'หมายเลขการสั่งซื้อ :',
      voucherOrderDate: 'วันที่การสั่งซื้อ :',
      status: 'สถานะ :',
      product: 'สินค้า',
      price: 'ราคา',
      quantity: 'จำนวน',
      taxInvoiceAddress: 'ที่อยู่สำหรับออกใบกำกับภาษี :',
      total: 'รวมทั้งหมด',
      failed: 'ไม่สำเร็จ',
      success: 'สำเร็จ',
      all: 'ทั้งหมด'
    }
  },
  unableItem: {
    bodyMessage: 'ไม่พบสินค้าที่ค้นหา',
    urlMessage1: 'ไปที่',
    urlMessage2: 'หน้าหลัก'
  },
  aboutUsPage: {
    items: [
      {
        title: 'จุดเริ่มต้น',
        img: '/assets/img/about-us/about_us_01.jpg',
        paragraph: [
          'เรารู้ดีว่าโลกของภาพยนตร์นั้นเป็นมากกว่า',
          'ที่เราสามารถชมได้ผ่านจอยักษ์กับเสียงที่อลังการในโรงภาพยนตร์',
          'เราเข้าใจดี และรู้ว่ายังมีกลุ่มลูกค้าที่เป็นแฟนตัวยง',
          'ของภาพยนตร์ต่าง ๆ ที่ออกจากโรงภาพยนตร์มาแล้วนั้น',
          'ต้องการที่จะเก็บ สะสม หรือรวบรวมสินค้าลิขสิทธ์แท้ต่าง ๆ',
          'เพื่อเป็นที่ระลึกหรือคุณค่าความทรงจำที่ดีต่อประสบการณ์',
          'ในโรงภาพยนตร์และภาพยนตร์นั้น ๆ'
        ]
      },
      {
        title: 'สร้างความสุข',
        img: '/assets/img/about-us/about_us_02.jpg',
        paragraph: [
          'เราเชื่อว่าทุกคนล้วนมีความสุขกับการได้ดูหนัง',
          'ในโรงภาพยนตร์และมีจินตนาการที่ล้ำลึก',
          'อีกทั้งต้องการสะสมตัวละครต่าง ๆ หรือไอเทมสุดพิเศษ',
          'เพื่อนำไปประดับบ้าน หรือห้องของคุณ'
        ]
      },
      {
        title: ['ใส่ใจ มั่นใจ', 'และตั้งใจ'],
        img: '/assets/img/about-us/about_us_03.jpg',
        paragraph: [
          'เราใส่ใจในการเลือกไอเทมและสินค้าอย่างเต็มที่',
          '',
          'เรามั่นใจว่าสินค้าที่เราเลือกมานั้น มีคุณภาพ',
          'ไม่ว่าจะเป็นความสุขเล็ก ๆ หรือความสุขอันยิ่งใหญ่',
          'เรามั่นใจว่าไอเทมเหล่านี้จะสร้างพื้นที่ความสุขให้กับคุณ',
          'หรือเป็นของขวัญชิ้นพิเศษได้อย่างแน่นอน',
          '',
          'เราตั้งใจทำ SF Shop ให้กับทุก ๆ คน เริ่มตั้งแต่',
          'เสื้อผ้า ของเล่น ตุ๊กตา หรือสินค้าตั้งโชว์',
          'ที่จะมอบช่วงเวลาดี ๆ หลังจากการชมภาพยนตร์'
        ]
      },
      {
        title: 'แล้วยังไงต่อ...',
        img: '/assets/img/about-us/about_us_04.jpg',
        paragraph: [
          'คุณสามารถซื้อสินค้าผ่านช่องทางออนไลน์ของเราได้เพียงไม่กี่คลิก',
          'หรือคุณสามารถเยี่ยมชมร้านของเราได้ที่สาขา',
          {
            text: 'เช็คสาขาได้ที่นี่: ',
            tag: {
              tagName: 'Link',
              text: 'คลิก',
              props: { to: '/branches' }
            }
          }
        ]
      }
    ]
  },
  branchesPage: {
    branch: [
      {
        nameEn: 'SF WORLD CINEMA',
        nameTh: 'เอส เอฟ เวิลด์ ซีเนม่า เซ็นทรัลเวิลด์',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: 'บริเวณชั้น 7 ติดบันไดเลื่อนทางขึ้นโรงภาพยนตร์',
        img: '/assets/img/branch/SFW.jpg'
      },
      {
        nameEn: 'SFC MBK CENTER',
        nameTh: 'เอส เอฟ ซีเนม่า เอ็มบีเค เซ็นเตอร์',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-21:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-21:00',
        detail: 'บริเวณชั้น 7 ตรงข้ามจุดจำหน่ายบัตรชมภาพยนตร์',
        img: '/assets/img/branch/MBK.jpg'
      },
      {
        nameEn: 'SF TERMINAL 21',
        nameTh: 'เอส เอฟ ซีเนม่า เทอร์มินอล 21 อโศก',
        floor: '6th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: 'บริเวณชั้น 6 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/T21.jpg'
      },
      {
        nameEn: 'SFC THE MALL BANGKAPI',
        nameTh: 'เอส เอฟ ซีเนม่า เดอะมอลล์ บางกะปิ',
        floor: '4th Floor',
        timeEn: 'Operating Hours : 10:00-21:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-21:00',
        detail: 'บริเวณชั้น 4 หน้าเคาน์เตอร์จำหน่ายบัตรชมภาพยนตร์',
        img: '/assets/img/branch/BKP.jpg'
      },
      {
        nameEn: 'SFX CENTRAL RAMA9',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เซ็นทรัล พระราม 9',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: 'บริเวณชั้น 7 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/RM9.jpg'
      },
      {
        nameEn: 'SFX CENTRAL CHAENGWATTANA',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เซ็นทรัลพลาซา แจ้งวัฒนะ',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-20:00',
        detail: 'บริเวณชั้น 7 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/CWN.jpg'
      },
      {
        nameEn: 'SFX THE MALL NGAMWONGWAN',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เดอะมอลล์ งามวงศ์วาน',
        floor: '7th Floor',
        timeEn: 'Operating Hours : 10:00-20:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-20:00',
        detail: 'บริเวณชั้น 7 หน้าบันไดเลื่อนทางเข้าโรงภาพยนตร์',
        img: '/assets/img/branch/NWW.jpg'
      },
      {
        nameEn: 'SFX CENTRAL LARDPRAO',
        nameTh: 'เอส เอฟ เอ็กซ์ ซีเนม่า เซ็นทรัลพลาซา ลาดพร้าว',
        floor: '6th Floor',
        timeEn: 'Operating Hours : 10:00-22:00',
        timeTh: 'เวลาเปิดทำการ : 10:00-22:00',
        detail: ['บริเวณบันไดเลือนทางขึ้น ', 'ทางเข้าโรงภาพยนตร์เทอร์มินอลบี'],
        img: '/assets/img/branch/LPO.jpg'
      }
    ]
  },
  HowToBuyPage: {
    title: 'วิธีการสั่งซื้อ',
    select: 'เลือกสินค้า',
    add: 'เพิ่มลงตะกร้า',
    check: 'ตรวจสอบรายการสินค้า',
    payment: 'เลือกช่องทางการชำระเงิน',
    shipping: 'เลือกวิธีการรับสินค้า'
  },
  dialogProductReview: {
    rating: {
      '1': 'ไม่พอใจมาก',
      '2': 'ไม่พอใจ',
      '3': 'พอใจ',
      '4': 'ดี',
      '5': 'ดีมาก'
    },
    placeholder: 'คุณมีความคิดเห็นอย่างไรเกี่ยวกับสินค้าชิ้นนี้',
    productRating: 'ให้คะแนนสินค้า',
    theQualityOfTheProductsIsFair: 'คุณภาพของสินค้าพอใช้',
    fairValue: 'ความคุ้มค่าพอใช้',
    fastDelivery: 'ความรวดเร็วในการจัดส่งพอใช้',
    shopIsFair: 'การให้บริการจากร้านค้าพอใช้',
    transportationServiceIsFair: 'การให้บริการจากบริการขนส่งพอใช้',
    buttonUploadPicture: `อัพโหลดรูปภาพ`,
    buttonCancel: 'ยกเลิก',
    buttonConfirm: 'ยืนยัน',
    maxFiles: 'สูงสุด 5 ไฟล์',
    warningMaxFiles: 'อนุญาตให้อัพโหลดภาพสูงสุด 5 ไฟล์'
  }
};
